import * as React from "react";

import { ExperimentEditContext } from "@/features/experiments/contexts/ExperimentEditContext";
import { useRequiredContext } from "replo-utils/react/context";

export function useExperimentEdit() {
  return useRequiredContext(ExperimentEditContext);
}
